import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TableInstance } from 'react-table';

import { WordLetterTemplate } from '@work4all/models/lib/Classes/WordLetterTemplate.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { OrganisationArea } from '../organisation-area';

import { EntityTable, IEntityTable } from './entity-table/EntityTable';
import { useEntityDataTable } from './entity-table/use-entity-data-table';
import schema from './schemata/wordLetterTemplate-table-schema.json';

type ILetterTemplateCustomColumns = Record<string, never>;

const defaultSort = [{ field: 'body', direction: SortDirection.ASCENDING }];

const FORCE_REQUEST_FIELDS: WordLetterTemplate = {
  groupId: null,
};

export const WordLetterTemplateTable = React.forwardRef<
  TableInstance,
  IEntityTable
>(function WordLetterTemplateTable(props, ref) {
  const { forceRequestFields, ...rest } = props;

  const { t } = useTranslation();

  const dataTable = useEntityDataTable<
    WordLetterTemplate,
    ILetterTemplateCustomColumns
  >({
    schema: schema as never,
    defaultSort,
    forceRequestFields: useMemo(
      () => ({ ...forceRequestFields, ...FORCE_REQUEST_FIELDS }),
      [forceRequestFields]
    ),
  });

  return (
    <EntityTable
      ref={ref}
      {...dataTable}
      areas={{
        left: {
          title: t('COMMON.ORGANISATION'),
          content: <OrganisationArea entity={Entities.wordLetterTemplate} />,
          resizable: true,
          collapsible: true,
          custom: true,
        },
      }}
      {...rest}
    />
  );
});
